import { adminSagas } from './modules/admin';
import { apiKeySagas } from './modules/api-key';
import { cpdCategorysSagas } from './modules/areas-of-advice';
import { businessSagas } from './modules/business';
import { configSagas } from './modules/configuration';
import { contentSagas } from './modules/content';
import { cpdPointSagas } from './modules/cpd-points';
import { dataGovSagas } from './modules/data-gov';
import { eventSagas } from './modules/event';
import { externalCpdSagas } from './modules/external-cpd';
import { geonamesSagas } from './modules/geonames';
import { globalSagas } from './modules/global';
import { industrySagas } from './modules/industry';
import { paymentSagas } from './modules/payment';
import { publisherSagas } from './modules/publisher';
import { publisherPortalSagas } from './modules/publisher-portal';
import { quizSagas } from './modules/quiz';
import { searchTileSagas } from './modules/search-tile';
import { sessionSagas } from './modules/session';
import { systemStatusSagas } from './modules/system-status';
import { taskSagas } from './modules/task';
import { userSagas } from './modules/user';
import { sagaMiddleware } from './store';

function run() {
  sagaMiddleware.run(cpdCategorysSagas);
  sagaMiddleware.run(contentSagas);
  sagaMiddleware.run(searchTileSagas);
  sagaMiddleware.run(configSagas);
  sagaMiddleware.run(cpdPointSagas);
  sagaMiddleware.run(dataGovSagas);
  sagaMiddleware.run(globalSagas);
  sagaMiddleware.run(industrySagas);
  sagaMiddleware.run(paymentSagas);
  sagaMiddleware.run(publisherSagas);
  sagaMiddleware.run(publisherPortalSagas);
  sagaMiddleware.run(quizSagas);
  sagaMiddleware.run(sessionSagas);
  sagaMiddleware.run(userSagas);
  sagaMiddleware.run(geonamesSagas);
  sagaMiddleware.run(businessSagas);
  sagaMiddleware.run(systemStatusSagas);
  sagaMiddleware.run(eventSagas);
  sagaMiddleware.run(externalCpdSagas);
  sagaMiddleware.run(adminSagas);
  sagaMiddleware.run(apiKeySagas);
  sagaMiddleware.run(taskSagas);
}

export default { run };



// WEBPACK FOOTER //
// ./src/state/rootSaga.js